// removed by extract-text-webpack-plugin
module.exports = {"summaryDates":"summaryDates___1DBXp","summaryDates__counter":"summaryDates__counter___3YNRi","summaryDates__button":"summaryDates__button___2xtR7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormDate/SummaryDates.module.scss
// module id = 2186
// module chunks = 0